/**
 * Ghép địa chỉ hiển thị: (phường, quận, tỉnh) nếu có.
 */
export function formatLocationAddress(item = {}) {
  const tail = [item.ward, item.district, item.city]
    .map((s) => String(s ?? "").trim())
    .filter(Boolean);
  const tailStr = tail.join(", ");
  return tailStr;
}

/** Chuỗi dùng để search/filter phía client (lowercase). */
export function locationAddressSearchText(item = {}) {
  return [
    item.ward,
    item.district,
    item.city,
    formatLocationAddress(item),
  ]
    .map((s) => String(s ?? "").toLowerCase())
    .filter(Boolean)
    .join(" ");
}

/** Có ít nhất một phần địa chỉ để hiển thị khối địa chỉ. */
export function hasFormattedAddress(item = {}) {
  return Boolean(String(formatLocationAddress(item) || "").trim());
}
